import moment from "moment";
import { FC, useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import Button from '../../Button';
import styled from "styled-components";
import { AiOutlineLeftCircle, AiOutlineRightCircle } from "react-icons/ai";
import { IGetNotifications, INotificationItem } from "../../../models/notification.model";
import _ from "lodash";
import useAxios from "../../../hooks/useAxios";
import { getNotifications } from "../../../api/notification.api";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import CreateNoticeModal2 from "./modals/CreateNoticeModal2";
import ShowNoticeModal2 from "./modals/ShowNoticeModal2";
import { CustomCalendar } from '../../../pages/program/holiday';
import PrevBtn from '../../../../public/images/btn_pre2.svg';
import NextBtn from '../../../../public/images/btn_next2.svg';

const Block = styled.div`
  .arrow > * {
    font-size: 24px;
  }

  .date {
    font-size: 18px;
  }

  .rbc-event {
    text-align: center;
  }
`;

moment.locale('ko');
const localizer = momentLocalizer(moment);

interface IProps {
  classCode: string;
  className?: string|undefined;
  isTutor?: boolean;
}

const ClassNotice2: FC<IProps> = ({
  classCode,
  className,
  isTutor = false,
}) => {
  const { t, i18n } = useTranslation();
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { chosenClass } = useSelector((state: RootState) => state.class);
  const { data: res, isLoading, error, execute } = useAxios<IGetNotifications>();

  const [data, setData] = useState<INotificationItem[]>([]);
  const [event, setEvent] = useState<any>();
  const [events, setEvents] = useState([]);
  const [year, setYear] = useState(0);
  const [month, setMonth] = useState(0);
  const [day, setDay] = useState(0);
  const [date, setDate] = useState<any>();
  const [createNoticeVisible, setCreateNoticeVisible] = useState(false);
  const [showNoticeVisible, setShowNoticeVisible] = useState(false);

  useEffect(() => {
    if (classCode) {
      doGetClassNotice();
    }
  }, [classCode]);

  useEffect(() => {
    if (res) {
      setData(res.data);
    }
  }, [res]);

  useEffect(() => {
    if (data) {
      const _data = _.cloneDeep(data).sort((a: any, b: any) => a.timetableDate < b.timetableDate ? -1 : (a.timetableDate > b.timetableDate ? 1 : 0));
      const _events: any = [];
      _data.forEach((item, index) => {
        const year = Number(item.timetableDate.slice(0, 4));
        const month = Number(item.timetableDate.slice(4, 6)) - 1;
        const day = Number(item.timetableDate.slice(6));
        _events.push({
          id: item.timetableCode,
          title: `${t('class.class.button13')}`,
          allDay: true,
          start: new Date(year, month, day),
          end: new Date(year, month, day + 1),
          resource: {
            type: 'new',
            index,
            semesterCourseCode: item.semesterCourseCode,
            timetableSeq: item.timetableSeq,
            timetableCode: item.timetableCode,
            resvYn: 'N',
          }
        });
        item.notifications.forEach(subitem => {
          if (subitem.notificationCode) {
            _events.push({
              id: subitem.notificationCode,
              title: subitem.subjectName,
              // title: getSubjectInitial(subitem.subjectName || ''),
              allDay: true,
              start: new Date(year, month, day),
              end: new Date(year, month, day + 1),
              resource: {
                type: subitem.noticeType,
                index,
                semesterCourseCode: item.semesterCourseCode,
                timetableSeq: item.timetableSeq,
                timetableCode: item.timetableCode,
                resvYn: subitem.resvYn,
              }
            });
          }
        })
      });
      setEvents(_events);
    }
  }, [data]);

  useEffect(() => {
    if (serverDate) {
      const _date = moment(serverDate);
      setYear(Number(_date.format('YYYY')));
      setMonth(Number(_date.format('M')) - 1);
      setDay(Number(_date.format('D')));
      setDate(_date);
    }
  }, [serverDate]);

  const doGetClassNotice = () => {
    if (!classCode) return;
    execute(getNotifications(classCode));
  }

  const onSetPrevMonth = () => {
    if (month === 0) {
      setYear(year - 1);
      setMonth(11);
    } else {
      setMonth(month - 1);
    }
    setDay(1);
  }

  const onSetNextMonth = () => {
    if (month === 11) {
      setYear(year + 1);
      setMonth(0);
    } else {
      setMonth(month + 1);
    }
    setDay(1);
  }

  const setToday = () => {
    setYear(Number(date.format('YYYY')));
    setMonth(Number(date.format('M')) - 1);
    setDay(Number(date.format('D')));
  }

  // const getSubjectInitial = (subjectName: string) => {
  //   switch (subjectName) {
  //     case 'Phonics':
  //       return 'P';
  //     case 'Reading':
  //       return 'R';
  //     case 'Grammar':
  //       return 'G';
  //     case 'Novel':
  //       return 'NV';
  //     case 'Writing':
  //       return 'W';
  //     case 'Speaking':
  //       return 'S';
  //     case 'Listening':
  //       return 'L';
  //     case 'Musical':
  //       return 'M';
  //     case 'Newspaper':
  //       return 'NP';
  //     default:
  //       return subjectName;
  //   }
  // }

  const onOpenCalendarEvent = (e: any) => {
    setEvent(e);

    if (e.resource.type === 'new') {
      // if (writeAuthYn === 'Y')
        setCreateNoticeVisible(true);
      // else
      //   return infoNotification('등록 권한이 없습니다.');
    } else {
        setShowNoticeVisible(true);
    }
  }  

  const CustomEvent = (item: any) => {
    return (
      <div className={(item.event.resource.resvYn==='Y'?'icon-alarm':'')}>
        {item.title}
      </div>
    );
  };

  return (
    <Block>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      {
        isTutor
          ? null
          : (
            <div className="comm-bx__between"> 
              <h3 className="sub-title">
                {chosenClass?.className}
              </h3>
            </div>
            )
      }
      <div className="mt-3 flex">
        <div className="col-2 pl-0">
          <Button
            className="btn-basic pink-line"
            onClick={setToday}
            text={t('program.holiday.button1')}
          />
        </div>
        <Block className="col-8 text-center">
          <h5 className="d-inline-flex align-items-center">
              <span className="arrow mr-3 pointer">
                <img src={PrevBtn} onClick={onSetPrevMonth} alt={'이전버튼'} />
              </span>
            <span className="date">
                {
                  i18n.language === 'ko'
                    ? `${year} · ${(month + 1).toString().length > 1 ? '' : 0}${month + 1}`
                    : `${month + 1}·${year}`
                }
              </span>
            <span className="arrow ml-3 pointer">
                <img src={NextBtn} onClick={onSetNextMonth} alt={'다음버튼'} />
            </span>
          </h5>
        </Block>
        <div className="col-2" />
      </div>
      <div className="class-notice">
        <CustomCalendar
          localizer={localizer}
          culture={i18n.language === 'ko' ? 'ko-KR' : 'en-US'}
          events={events}
          date={new Date(year, month, day)}
          onSelectEvent={e => onOpenCalendarEvent(e)}
          selectable
          toolbar={false}
          style={{ minHeight: '900px', margin: '10px 0' }}
          // @ts-ignore
          dayPropGetter={date => {
            if (date.getDay() === 0 || date.getDay() === 6) {
              return { style: { background: '#fbfbfc' } };
            }
          }}
          // @ts-ignore
          eventPropGetter={(event: any) => {
            switch (event.resource.type) {
              case 'new':
                return { style: { background: '#bb0665' } };
              case 'HW' :
                //숙제
                return { style: { background: '#65c1c1' } };
              case 'AN' :
                //알림
                return { style: { background: '#7F7F7F' } }
              default:
                return { style: { background: '#65c1c1' } }
            }
          }}
          dayLayoutAlgorithm='no-overlap'  
          showAllEvents={true}
          components={{
            event: CustomEvent,
          }}
        />
      </div>

      {
        createNoticeVisible &&
          <CreateNoticeModal2
            visible={createNoticeVisible}
            setVisible={setCreateNoticeVisible}
            event={event}
            doGetClassNotice={doGetClassNotice}
            isTutor={isTutor}
            className={className}
          />
      }
      {
        showNoticeVisible &&
          <ShowNoticeModal2
            visible={showNoticeVisible}
            setVisible={setShowNoticeVisible}
            event={event}
            doGetClassNotice={doGetClassNotice}
            isTutor={isTutor}
            className={className}
          />
      }
    </Block>
  );
}

export default ClassNotice2;
